import { API_BASE_URL_ENV } from "../common/common";
import BaseService from "./BaseService";
import http from './HttpService'


const apiEndpoint = API_BASE_URL_ENV() + "/banner";

export default class BannerService extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
}
